<template>
	<div v-if="showResult" class="result-div">
		<h3>{{$t('email.SuccessTip')}}<span class="text-danger">{{$t('home.Set')}}</span></h3>
		<p><img src="../assets/success.png" height="30" alt=""><b class="text-danger">{{$t('email.BoundtoEmail')}}:</b><span>{{bind.email}}</span></p>
		<wd-button type="danger" @click.native="showResult = false" size="large" :styles="{width:'300px'}">{{$t("email.ChangetheEmail")}}</wd-button>
	</div>
	<div id="phone" class="form-container" v-else>
		<template v-if="!unbind.email">
			<h2>{{$t('email.Emailbinding')}}</h2>
			<div class="form-item">
				<label for="">{{$t("email.Email")}}</label>
				<input type="text" 
					@focus="validated = false"
					v-model="bind.email" 
					:class="(validated && !bind.email) ? 'error' : ''" 
					:placeholder="$t('email.EmailTip')" />
			</div>
			<div class="form-item code-item">
				<label for="">{{$t("default.EmailAuthenticationCode")}}</label>
				<input type="text" 
					@focus="validated = false"
					class="code-input" 
					maxlength="6" 
					:class="(validated && !bind.emailAuthenticationCode) ? 'error' : ''" 
					v-model="bind.emailAuthenticationCode" 
					:placeholder="$t('default.VerificationCodeTip')" />
				<span>
					<wd-button 
						ref="bindCodeBtn"
						@click.native="sendEmailCode('bind')"
						type="info" 
						size="small" 
						:styles="{height:'44px'}"
						>{{$t('default.SendVerificationCode')}}</wd-button>
				</span>
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" @click.native="binding" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
			</div>
		</template>
		<template v-else>
			<h2>{{$t('email.UnbindtheEmail')}}</h2>
			<div class="form-item">
				<label for="">{{$t("email.Email")}}</label>
				<span>{{unbind.email}}</span>
				<a :href="'http://www.wooduan.com/service?lang='+($i18n.locale=='zh'?'zh':'en')" target="_blank" style="margin-left: 10px; color: #c72729;font-size: 12px">{{$t('email.Emaillossorabnormity')}}</a>
			</div>
			<div class="form-item code-item">
				<label for="">{{$t("default.EmailAuthenticationCode")}}</label>
				<input type="text"
					@focus="validated = false" 
					class="code-input" 
					maxlength="6" 
					v-model="unbind.emailAuthenticationCode" 
					:placeholder="$t('default.VerificationCodeTip')" 
					:class="(validated && !unbind.emailAuthenticationCode) ? 'error' : ''" />
				<span>
					<wd-button 
						ref="unBindCodeBtn"
						@click.native="sendEmailCode('unBind')"
						type="info" 
						size="small" 
						:styles="{height:'44px',padding:'5px 15px'}">
						{{$t('default.SendVerificationCode')}}
					</wd-button>
				</span>
			</div>
			<div class="form-item code-item">
				<label for="">{{$t("default.VerificationCode")}}</label>
				<input type="text" 
					@focus="validated = false"
					class="code-input" 
					maxlength="4" 
					v-model="unbind.verificationCode" 
					:placeholder="$t('default.VerificationCodeTip')" 
					:class="(validated && !bind.verificationCode) ? 'error' : ''">
				<v-code></v-code>
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" @click.native="unbinding" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
			</div>
		</template>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import VerificationCode from '@/components/VerificationCode.vue';
	export default{
		name:"email",
		data(){
			return {
				bind:{
					email:"",
					emailAuthenticationCode:"",
				},
				unbind:{
					email:"",
					verificationCode:"",
					emailAuthenticationCode:"",
				},
				validated:false,
				showResult:false,
			}
		},
		components:{
			'wd-button':WdButton,
			'v-code':VerificationCode
		},
		async created(){
			let user = await this.$getUser();
			if(user){
				this.unbind.email = user.email;
			}
		},
		
		methods:{
			async binding(){
				this.validated = true;
				var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
				if(!this.bind.email){
					this.$alert(this.$t("email.EmailTip"))
					return;
				}
				if(!reg.test(this.bind.email.toLowerCase())){
					this.$alert(this.$t("email.EmailFormat"))
					return;
				}
				if(!this.bind.emailAuthenticationCode){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}

				let response = await this.$api.post('/web/index/bindEmail',{email:this.bind.email,code:this.bind.emailAuthenticationCode});
				if(response.code == 0){
					this.showResult = true;
					this.unbind.email = this.bind.email;
					this.$setUser({email:this.bind.email})
					this.$refs['bindCodeBtn'].endWait();
				}else if(response.code ==  10003){
					this.$alert(this.$t('default.EmailCodeErr'));
				}else{
					this.$alert(response.msg);
				}
			},
			async unbinding(){
				this.validated = true;
				if(!this.unbind.email){
					this.$alert(this.$t("email.EmailTip"))
					return;
				}
				if(!this.unbind.emailAuthenticationCode){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}
				if(!this.unbind.verificationCode){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}

				let response = await this.$api.post('/web/index/unBindEmail',{email:this.unbind.email,code:this.unbind.emailAuthenticationCode,image_code:this.unbind.verificationCode});
				if(response.code == 0){
					this.$alert(this.$t('email.UnbindingEmailSuccessfully'));
					this.showResult = false;
					this.unbind.email = "";
					this.bind.email = "";
					this.$setUser({email:""})
					this.$refs['unBindCodeBtn'].endWait();
				}else if(response.code == 10003){
					this.$alert(this.$t('default.EmailCodeErr'));
				}else if(response.code ==  10004){
					this.$alert(this.$t('default.ImgCodeErr'));
				}else{
					this.$alert(response.msg);
				}
			},
			async sendEmailCode(type){
				if(type == 'bind'){
					this.$refs['bindCodeBtn'].sendEmailCode(type,this.bind.email);
				}else{
					this.$refs['unBindCodeBtn'].sendEmailCode(type,this.unbind.email);
				}
			}
		},

		
	}
</script>
<style scoped>
	.form-container{
		margin-top: 50px;
	}
</style>
